export default {
    nav: {
        home: '首页',
        about: '实验室概况',
        team: '学术团队',
        research: '科研成果',
        resources: '实验室资源',
        contact: '联系我们',
        recruitment: '招生与就业'
    },
    header: {
        labName: '具身智能与智慧医疗实验室',
        labNameEn: 'Embodied and Medical Intelligence Lab',
        uestc: '电子科技大学',
        uestcSz: '电子科技大学（深圳）高等研究院'
    },
    footer: {
        about: '关于我们',
        research: '研究成果',
        contact: '联系我们',
        copyright: '© 2025 具身智能与智慧医疗实验室 版权所有',
        addressInfo: '地址：深圳市龙华区观澜街道新澜社区观光路1301-80号银星智界二期 | 邮箱：EMIL_Lab@126.com'
    },
    home: {
        heroTitle: '欢迎来到具身智能与智慧医疗实验室',
        heroSubtitle: '探索前沿科技，共创美好未来',
        directorContact: '团队主任联系方式',
        name: '姓名：',
        title: '职称：',
        email: '邮箱：',
        office: '办公室：',
        officeHours: '办公时间：',
        directorName: '范衠',
        directorTitle: '教授/博士生导师',
        directorEmail: 'fanzhun@uestc.edu.cn',
        directorOffice: '深圳市龙华区观澜街道新澜社区观光路1301-78号银星智界二期2号楼',
        directorHours: '周一至周五 9:00-17:00，周末及节假日休息',
        notices: '通知公告',
        dailyRecommend: '每日推荐'
    },
    about: {
        heroTitle: '实验室概况',
        heroSubtitle: '了解我们的历史、使命和研究方向',
        directorContact: '团队主任联系方式',
        name: '姓名：',
        title: '职称：',
        email: '邮箱：',
        office: '办公室：',
        officeHours: '办公时间：',
        directorName: '范教授',
        directorTitle: '教授/博士生导师',
        directorEmail: 'fanzhun@uestc.edu.cn',
        directorOffice: '深圳市龙华区观澜街道新澜社区观光路1301-78号银星智界二期2号楼',
        directorHours: '周一至周五 9:00-17:00，周末及节假日休息',
        labIntro: '实验室简介',
        researchDirections: '研究方向',
        researchIntro: '实验室致力人工智能与机器人的研究与应用，主要研究方向包括：'
    },
    team: {
        heroTitle: '学术团队',
        heroSubtitle: '汇聚顶尖人才，共创科研辉煌',
        professorTeam: '教师团队',
        studentTeam: '研究生团队'
    },
    research: {
        heroTitle: '科研成果',
        heroSubtitle: '探索创新，追求卓越',
        ourAchievements: '我们的研究成果',
        achievementsIntro: '人工智能与机器人实验室在多个研究领域取得了丰硕的成果，包括高水平学术论文、科研项目、专利技术和科研奖项。以下是我们的主要科研成果展示。',
        publications: '学术论文',
        highlight: 'Highlight',
        projects: '科研项目',
        verticalProjects: '纵向项目',
        horizontalProjects: '横向项目',
        patents: '专利成果',
        softwareCopyrights: '软著成果',
        awards: '科研获奖',
        videos: '成果视频',
        viewMorePapers: '查看更多论文 →',
        viewMoreProjects: '查看更多项目 →',
        viewMorePatents: '查看更多专利 →',
        viewMoreAwards: '查看更多奖项 →',
        viewMoreVideos: '查看更多视频 →',
        allPapersLoaded: '已加载全部论文',
        allHighlightLoaded: '已加载全部Highlight',
        allProjectsLoaded: '已加载全部项目',
        allPatentsLoaded: '已加载全部专利',
        allSoftwareCopyrightsLoaded: '已加载全部软著',
        allAwardsLoaded: '已加载全部奖项',
        allVideosLoaded: '已加载全部视频',
        paperCover: '论文封面',
        projectImage: '项目图片',
        patentCert: '专利证书',
        softwareCopyrightCert: '软著证书',
        awardCert: '获奖证书',
        videoCover: '视频封面',
        noPdf: '该成果暂未上传 PDF 文件',
        noVideo: '该成果暂未上传视频文件',
        browserNotSupport: '您的浏览器不支持视频播放。'
    },
    resources: {
        heroTitle: '实验室资源',
        heroSubtitle: '汇聚实验平台、算力平台和机器人装备，支撑科研验证与工程实践',
        categoryTitle: '资源分类',
        categoryIntro: '点击资源分类查看对应设备，选择列表条目可浏览该资源的实体图片和文字描述。',
        viewDetail: '查看详情 →',
        empty: '暂无资源数据',
        loadFailed: '加载失败，请稍后重试'
    },
    contact: {
        heroTitle: '联系我们',
        heroSubtitle: '期待与您交流合作',
        contactInfo: '联系方式',
        address: '地址',
        addressDetail: '深圳市龙华区观澜街道新澜社区观光路1301-80号银星智界二期3号楼406',
        phone: '电话',
        phoneDetail: '+86-18066104692（徐老师）',
        emailLabel: '邮箱',
        emailDetail: 'EMIL_Lab@126.com',
        officeHours: '办公时间',
        weekdays: '周一至周五：9:00-17:00',
        weekends: '周末及节假日休息',
        traffic: '交通指南',
        subway: '地铁：4号线长湖站B出口，步行20分钟',
        bus: '公交：电子科大深圳高研院站（M450路）',
        sendMessage: '发送消息',
        formName: '姓名',
        formEmail: '邮箱',
        formPhone: '电话',
        formSubject: '主题',
        selectSubject: '请选择主题',
        subjectResearch: '科研合作',
        subjectVisit: '参观访问',
        subjectInternship: '实习申请',
        subjectAdmission: '招生咨询',
        subjectOther: '其他',
        formMessage: '留言内容',
        submitBtn: '发送消息',
        submitSuccess: '您的留言已发送！'
    },
    notice: {
        back: '< 返回',
        loading: '加载中...',
        publishTime: '发布时间：',
        fetchError: '获取详情失败',
        networkError: '网络错误，请重试',
        retry: '重试'
    },
    teamDetail: {
        heroTitle: '学术团队',
        heroSubtitle: '汇聚顶尖人才，共创科研辉煌',
        email: '邮箱：',
        office: '办公室：',
        officeHours: '办公时间：',
        education: '教育背景',
        workExperience: '工作经历',
        researchInterests: '研究兴趣',
        publications: '代表性论文',
        projects: '科研项目',
        backToTeam: '返回学术团队'
    }
}
